import { storeManager } from '@pressreader/appstore';

import { CONFIG_MODULE_NAME } from '../constants';

import { reducer } from './reducer';
import { saga } from './sagas';

storeManager.addFeature(CONFIG_MODULE_NAME, reducer, saga);

export {
    configChanged,
    configLoadBegan,
    configLoadDone,
    configLoadFailed,
    extendConfigAction,
    forceConfigLoadDoneAction,
    loadConfigAction,
} from './actions';
export { selectConfig, selectConfigValue, selectGetConfigBoolValue, selectGetConfigValue, selectStatus } from './selectors';
export * from './utils';
